<label class="container">{{ label }}
    <input class="input"
    v-bind="$attrs" type="checkbox" :checked="checked"
        @change="$emit('update:checked', $event.target.checked)" />
        <span class="checkmark"></span>
</label>